var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { loading } from '../../../elements/Loading';
import { FieldType } from '../../../elements';
import { rules } from '../../../helpers/Validation';
import { Form } from 'components';
import { t } from '../../../helpers/i18n';
var AfiliateForm = /** @class */ (function (_super) {
    __extends(AfiliateForm, _super);
    function AfiliateForm(props) {
        var _this = _super.call(this, props) || this;
        _this.TypeCommission = {
            // Fix: 'fix',
            Percentage: 'percentage'
        };
        _this.typeCommissions = Object.entries(_this.TypeCommission).map(function (item) {
            return ({
                name: t("".concat(item[1])),
                value: item[1]
            });
        });
        _this.fields = [
            {
                name: 'name',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required(),
                size: 3
            },
            {
                name: 'email',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .email(),
                size: 3,
                tooltipId: 'email',
                tooltip: 'email que recibe el afiliado cuando se produce una venta como afiliado'
            },
            {
                name: 'commission',
                type: FieldType.Text,
                rules: rules()
                    .number(),
                size: 3
            },
            {
                name: 'typeCommission',
                type: FieldType.Select,
                rules: rules().string(),
                options: __spreadArray([], _this.typeCommissions, true),
                size: 3
            },
            {
                name: 'calcImport',
                type: FieldType.Checkbox,
                rules: rules().boolean(),
                size: 3
            }
        ];
        return _this;
    }
    AfiliateForm.prototype.render = function () {
        var afiliate = this.props.afiliate;
        var afiliateStore = this.props.store.afiliateStore;
        var urlMainAfiliate = "https://widget.ticando.net/";
        return (React.createElement(React.Fragment, null,
            React.createElement(Form, { reactstrap: true, loading: ['post@afiliates', 'put@afiliates'], fields: this.fields, values: afiliate, store: afiliateStore, stores: this.props.store })));
    };
    AfiliateForm = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.match.params.id ? props.store.afiliateStore.read(props.match.params.id).then(function (afiliate) { return ({ afiliate: afiliate }); }) : undefined
        ]; }),
        observer
    ], AfiliateForm);
    return AfiliateForm;
}(Component));
export default AfiliateForm;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Afiliates/containers/AfiliateForm.tsx
// module id = 1573
// module chunks = 0